/**
 * Login.js
 */

require.config({
    baseUrl: '../../'
});

require(["loginController", "loginLibs"], function () {
    initializeLoginCtrl();
});
define("login", function(){});

